import React from "react";
import notification from "../../../Assets/img/megaphone.svg";


const Topbar = props => {

  return (
         <div
          className="alert notification mb-0 alert-dismissible fade show d-flex justify-content-around"
          role="alert"
        >
          <div className="container text-xs-center">
            <button
              type="button"
              className="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p>
            <i className="mr-2">
              <img src={notification} alt="" />
            </i>
            The inaugural edition of Puzzled is now live </p>
          </div>
        </div>
  );
};

export default Topbar;
